<template>
    <div>

        <critical-banner v-if="order.critical" text="Dieser Auftrag ist seit drei Tagen in Bearbeitung!"></critical-banner>

    </div>

    <div class="grid grid-cols-2 md:grid-cols-3 gap-6 w-full items-center justify-items-end">

        <page-title class="justify-self-start" :title="$t('orders.title') +' ' +  order.number"></page-title>

        <div class="sm:col-span-2">
            <div class="sm:hidden">
                <label for="tabs" class="sr-only">Select a tab</label>
                <select id="tabs" name="tabs"
                        @change="navigate($event.target.value)"
                        class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
                    <option v-for="tab in tabs" :key="tab.name" :selected="route().current(tab.route)" :value="tab.route">{{ tab.name }}</option>
                </select>
            </div>
            <div class="hidden sm:block">
                <nav class="flex space-x-4" aria-label="Tabs">
                    <Link v-for="tab in tabs"
                          :key="tab.name"
                          :href="route(tab.route, this.order.id)"
                          :class="[route().current(tab.route) ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:text-gray-800', 'px-3 py-2 font-medium text-sm rounded-md']"
                          :aria-current="route().current(tab.route) ? 'page' : undefined">
                        {{ tab.name }}
                    </Link>
                </nav>
            </div>
        </div>

    </div>

    <slot></slot>
</template>

<script>
import PageTitle from "@/Shared/Components/PageTitle";
import CriticalBanner from "@/Pages/Sales/Order/Components/CriticalBanner";
import OrderState from "@/Pages/Sales/Order/Components/OrderState";
import OrderHead from "@/Pages/Sales/Order/Components/OrderHead";
import OrderAddress from "@/Pages/Sales/Order/Components/OrderAddress";
import OrderTaxTable from "@/Pages/Sales/Order/Components/OrderTaxTable";
import OrderContact from "@/Pages/Sales/Order/Components/OrderContact";
import OrderTracking from "@/Pages/Sales/Order/Components/OrderTracking";
import {Link} from "@inertiajs/vue3";

const tabs = [
    {name: 'Übersicht', route: 'sales.orders.view', current: 'sales.orders.view'},
    {name: 'Steuern', route: 'sales.orders.taxes', current: 'sales.orders.taxes'},
    {name: 'Events', route: 'sales.orders.events', current: 'sales.orders.events'},
]
export default {
    props: ['order'],
    components: {
        OrderTracking,
        OrderContact,
        OrderTaxTable,
        OrderAddress,
        OrderHead,
        OrderState,
        CriticalBanner,
        PageTitle,
        Link
    },
    setup() {
        return {
            tabs,
        }
    },
    methods: {
        navigate(route) {
            this.$inertia.visit(this.route(route, this.order.id), {
                preserveScroll: true,
            })
        }
    }
}
</script>

<style scoped>

</style>
